export const SunMark = ({ className = "" }) => (
  <svg viewBox="0 0 64 52" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="tsmGold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#F3E5AB" />
        <stop offset=".5" stopColor="#D4AF37" />
        <stop offset="1" stopColor="#9A6E12" />
      </linearGradient>
    </defs>
    <g stroke="url(#tsmGold)" strokeWidth="1.4" strokeLinecap="round">
      <path d="M32 7V2M21 11l-3-4M43 11l3-4M14 19l-4-2M50 19l4-2M25 8.5l-1.5-4.5M39 8.5l1.5-4.5" />
    </g>
    <path d="M18 29a14 14 0 0 1 28 0z" fill="url(#tsmGold)" />
    <path d="M6 32c9-3 18-2 26 6 8-8 17-9 26-6-8 1-16 4-26 12C22 36 14 33 6 32z" fill="url(#tsmGold)" />
  </svg>
);

export const Logo = ({ onClick }) => (
  <a href="#top" onClick={onClick} className="flex items-center group" data-testid="header-logo-link">
    <img src="/img/logo_sm.png" alt="TSM WAY" className="h-14 md:h-16 w-auto transition-transform duration-500 group-hover:-translate-y-0.5 drop-shadow-[0_4px_14px_rgba(212,175,55,0.25)]" />
  </a>
);
